/**
 * Course resource ids per topic (metadata only).
 * PDFs/planilhas do curso não são servidos pelo app · o usuário anexa os próprios arquivos em Documentos.
 */

import arquivosData from '@content/arquivos-uteis.json'

function buildRecursosPorTopico(): Map<string, string[]> {
  const map = new Map<string, string[]>()
  for (const arq of arquivosData.arquivos) {
    for (const topicoId of arq.topicoIds ?? []) {
      const list = map.get(topicoId) ?? []
      list.push(arq.id)
      map.set(topicoId, list)
    }
  }
  return map
}

const RECURSOS_POR_TOPICO = buildRecursosPorTopico()

/** Ids lógicos de recursos do guia (sem download de arquivos embutidos). */
export function getRecursoIdsForTopico(topicoId: string): string[] {
  return RECURSOS_POR_TOPICO.get(topicoId) ?? []
}
